export default __webpack_public_path__ + "static/media/rev_f_amp.30fe8e80.webp";